import { gql } from "@apollo/client";

export const CREATE_INSTAGRAM = gql`
  mutation CreateInstagram(
    $username: String!
    $migrate: Boolean
    $migrateFrom: String
  ) {
    createInstagram(
      username: $username
      migrate: $migrate
      migrateFrom: $migrateFrom
    ) {
      id
      username
      owner {
        id
      }
    }
  }
`;

export interface CreateInstagramData {
  createInstagram: {
    id: string;
    username: string;
    owner: { id: string };
  };
}

export interface CreateInstagramVariables {
  username: string;
  migrate?: boolean;
  migrateFrom?: string;
}
